import { useQuery } from '@tanstack/react-query';

import { ADMIN_API_URL_SUBPATH } from '@/constants';
import { axiosInstance } from '@/core';
import { USER_ROUTE } from '@/routes';

export const useGetUserInfo = () =>
  useQuery<{ username: string; is_active: boolean }>({
    queryKey: ['me'],
    enabled: true,
    queryFn: async () => {
      const response = await axiosInstance.get<{ username: string; is_active: boolean }>(
        `${ADMIN_API_URL_SUBPATH}${USER_ROUTE}/me`,
      );
      return response.data;
    },
  });
